import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getEstatesByGroupID,
    getDivisionsByEstateID,
    getWorkedInactiveEmployeeReportData
};

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;
}

async function getDivisionsByEstateID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetEveryDivisionsFromOperationEntitiyID', 'estateID=' + id);
    for (let item of Object.entries(response.data)) {
        divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
    }
    return divisionArray;
}

async function getWorkedInactiveEmployeeReportData(data) {
    const response = await CommonPost('/api/WorkedInactiveEmployeeReport/GetWorkedInactiveEmployeeReport', null, data);
    return response.data;
}